export const SetAuthToken=token=>{
    localStorage.setItem("token",token);
}
export const GetAuthToken=()=>{
    return localStorage.getItem("token")
}